export const HiddenColumnsForAgencyHierarchy: string[] = [
    "userId",
    "username",
    "userFirstName",
    "userLastName",
    "name",
    "agencyTypeName"
] ;

export const HiddenColumnsForAgencyHierarchyHeaders: string[] = [
    "User Id",
    "Username",
    "User First Name",
    "User Last Name",
    "Name",
    "Agency Type Name"
];